import { useRoutes } from "react-router-dom"

// project-imports
import ScoutingPublicRoutes from "./ScoutingPublicRoutes"
import { buildScoutingRoutes } from "./ScoutingRoutes"
import { useMemo } from "react"
import useAuth from "hooks/useAuth"

// ==============================|| ROUTES RENDER ||============================== //

export default function ThemeRoutes() {
  const { user } = useAuth()

  const routes = useMemo(() => {
    const scoutingRoutes = buildScoutingRoutes(user)
    return [ScoutingPublicRoutes, scoutingRoutes]
  }, [user])

  return useRoutes(routes)
}
